module.exports = __webpack_public_path__ + "static/media/graph.8ee8676c.png";